<template>
  <div class="diagnostics-page">
    <div class="app-card">
      <div class="list-toolbar">
        <pods-input ref="podsInput" />
        <div style="margin-left: auto">
          <UtcOffsets />
        </div>
      </div>

      <el-table
        border
        ref="table"
        :data="tableData"
        size="small"
        v-loading="loading"
        :max-height="tableHeight"
        class="app-table"
      >
        <el-table-column label="Serial #" prop="Serial" width="70" />
        <el-table-column :label="$t('text.mac_address')" prop="MacAddress" />
        <el-table-column label="Last Seen" prop="LastSeen">
          <template slot-scope="scope">
            {{
              moment
                .utc(scope.row.LastSeen)
                .tz($store.state.pods.selectedUtcOffset)
                .format('DD/MM/YYYY @ hh:mm a')
            }}
          </template>
        </el-table-column>
        <el-table-column label="PPM (last 7d)" prop="PPM" width="100" />
        <el-table-column label="Offline (7d)" width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.Offline[0]"
              >{{ scope.row.Offline[0] }}d
            </span>
            <span v-if="scope.row.Offline[1]"
              >{{ scope.row.Offline[1] }}h
            </span>
            <span v-if="scope.row.Offline[2]">{{ scope.row.Offline[2] }}m</span>
          </template>
        </el-table-column>
        <el-table-column label="Battery" prop="Battery" width="80" />
        <el-table-column label="Version" width="90">
          <template slot-scope="scope">
            <div>FW: {{ scope.row.FirmwareVersion }}</div>
            <div>HW: {{ scope.row.HardwareVersion }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Live Status">
          <template slot-scope="scope">
            <div>Sensor: {{ scope.row.ConnectionStatus }}</div>
            <div>Position: {{ scope.row.Position }}</div>
            <div>Falls: {{ scope.row.Falls }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Relayed Through Devices (7d)">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.DeviceArr" :key="index">
              {{ item }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Relayed Through Device MAC Address (7d)">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.DeviceMacArr" :key="index">
              {{ item }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { secondFormat } from '../../utils/utils'
import PodsInput from '@/components/PodsInput'
import UtcOffsets from '@/components/UtcOffsets'
import moment from 'moment'
import ApiService from '@/services/ReportApiService.js'
import swal from 'sweetalert'

export default {
  data() {
    return {
      moment,
      loading: false,
      tableData: [],
      tableHeight: 0
    }
  },
  components: {
    PodsInput,
    UtcOffsets
  },
  mounted() {
    this.getData()
    this.$nextTick(() => {
      this.tableHeight =
        window.innerHeight - this.$refs.table.$el.offsetTop - 150
      const self = this
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 150
      }
    })
  },
  watch: {
    '$store.state.pods.selectedPod': function() {
      this.getData()
    }
  },
  methods: {
    calculateTableData() {
      this.tableData = this.tableData.map(item => ({
        ...item,
        Offline: secondFormat(item.OfflineSecond),
        MacAddress: this.$store.state.pods.selectedPod.podId,
        Serial: this.$store.state.pods.selectedPod.podId.substring(
          this.$store.state.pods.selectedPod.podId.length - 6
        ),
        DeviceArr: item.Device ? item.Device.split(',') : [],
        DeviceMacArr: item.DeviceMac ? item.DeviceMac.split(',') : []
      }))
    },
    getData() {
      if (!this.$store.state.pods.selectedPod.podId) return false
      this.loading = true
      ApiService.GetPodDiagnostics(this.$store.state.pods.selectedPod.podId)
        .then(response => {
          this.loading = false
          if (response.data) {
            this.tableData = [response.data]
            this.calculateTableData()
          }
        })
        .catch(() => {
          this.loading = false
          this.calculateTableData()
          swal({ icon: 'error', timer: 2000, title: this.$t('text.failed') })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

.diagnostics-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.app-card {
  padding: 20px 24px;
  overflow-x: auto;
}

.list-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
</style>
